// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cbdec78c","952":"c6f7a449"}[chunkId] + ".chunk.js";
};